import axios from 'axios';

const customAxios = (accessToken) => {
  const axiosInstance = axios.create();

  axiosInstance.interceptors.request.use((config) => {
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: accessToken ? `Bearer ${accessToken}` : '',
        appid: config.headers?.appid || 'notifyadmin',
      },
    };
  });

  return axiosInstance;
};

export default customAxios;
